import React from 'react';
import { MainImage } from '../../../../Shared/Content/ProductDetail/ProductMainImage/ProductMainImage';
import { AltImages, MainImageSlider } from '../../../../Shared/Content/ProductDetail/ProductAltImages/ProductAltImages';
import { Title } from '../../../../Shared/Content/ProductDetail/ProductTitle/ProductTitle';
import { ProductReviewStars } from '../../../../Shared/Content/ProductDetail/ProductReviewStars/ProductReviewStars';
import { Price } from '../../../../../UI/Price/Price';
import { ProductRecs } from '../../../../../UI/ProductRecs/ProductRecs';
import { ProductDescription } from '../../../../Shared/Content/ProductDetail/ProductDescription/ProductDescription';
import { BrandDescription } from '../../../../Shared/Content/ProductDetail/BrandDescription/BrandDescription';
import { ProductShipping } from '../../../../Shared/Content/ProductDetail/ProductShipping/ProductShipping';
import ProductSocialMedia from '../../../../Shared/Content/ProductDetail/ProductSocialMedia/ProductSocialMedia';
import ProductDetailReviews from '../../../../Shared/Content/ProductDetail/ProductDetailReviews/ProductDetailReviews';
import ProductLeftRightEspot from '../../../../Shared/Content/ProductDetail/ProductLeftRightEspot/ProductLeftRightEspot';
import ProductItemComponent from '../../../../Shared/Content/ProductDetail/ProductItemComponent/ProductItemComponent';
import { AsNavFor } from '../ProductMainAndAltImages/ProductMainAndAltImages';
import { CloseXIcon } from '../../../../../UI/Icons/Icons';
import { PhotoSwipeZoom, MainImagePhotoSwipeZoom } from '../PhotoSwipeZoom/PhotoSwipeZoom';
import ProductRecommendations from '../../Layouts/Widgets/ProductRecommendations/ProductRecommendations';
import ProductMisc from '../../../../Shared/Content/ProductDetail/ProductMisc/ProductMisc';
import WcPowerPage from '../../../../Shared/Content/ProductDetail/ProductDisplay/WcPowerPage';

export class ProductItemDisplay extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      deviceWidth: '',
      isOpen: false,
      options: {
        showHideOpacity: true,
        allowPanToNext: true,
        maxSpreadZoom: 3,
        closeOnVerticalDrag: true,
        focus: true,
      },
    };

    this.zoomIndex = 0;
  }

  componentDidMount() {
    if (this.props.passedAppFunctions.siteFormat == 'desktop') {
      this.setState({ deviceWidth: window.outerWidth });

      this.desktopResizeHandler = _.debounce(() => this.setState({ deviceWidth: window.outerWidth }), 300);
      window.addEventListener('resize', this.desktopResizeHandler);
    } else {
      // Using window.innerWidth for Tablet. IOS 10 was returning window.outerWidth = 0
      this.setState({ deviceWidth: window.innerWidth });

      this.tabletResizeHandler = _.debounce(() => this.setState({ deviceWidth: window.innerWidth }), 300);
      window.addEventListener('resize', this.tabletResizeHandler);
    }
  }

  openPhotoSwipe = (e) => {
    e.preventDefault();
    this.setState({
      isOpen: true,
      options: {
        index: this.zoomIndex,
        closeOnScroll: false,
      },
    });
  };

  handleClose = () => {
    this.setState({
      isOpen: false,
    });
  };

  updateZoomIndex = (i) => {
    this.zoomIndex = i;
  };

  componentWillUnmount() {
    if (this.desktopResizeHandler) {
      window.removeEventListener('resize', this.desktopResizeHandler);
      this.desktopResizeHandler.cancel();
    }
    if (this.tabletResizeHandler) {
      // Using window.innerWidth for Tablet. IOS 10 was returning window.outerWidth = 0
      window.removeEventListener('resize', this.tabletResizeHandler);
      this.tabletResizeHandler.cancel();
    }
  }

  render() {
    var settings = {
      containsAlts: this.props.contentData.altImages ? true : false,
    };

    return (
      <section id='ProductItemDisplay'>
        <div className={`row m-0 ${this.props.passedFunctions.parentState.imageClickedOn ? 'hidden' : ''}`}>
          <div className='col-sm-12 col-md-12 col-lg-10'>
            <div className='row m-b-30'>
              {this.state.deviceWidth > 769 && this.props.passedAppFunctions.siteFormat != 'tablet' ? (
                <div className={`${settings.containsAlts ? 'col-sm-1' : 'col-sm-0'} p-0`}>
                  <AltImages
                    contentData={this.props.contentData}
                    passedFunctions={this.props.passedFunctions}
                    selectedMainImg={this.props.passedFunctions.parentState.selectedMainImg}
                    selectedAttributeValue={this.props.passedFunctions.parentState.selectedAttributeValue}
                    passedAppFunctions={this.props.passedAppFunctions}
                    altClicked={this.props.altClicked}
                  />
                </div>
              ) : (
                ''
              )}
              {this.props.contentData.altImages && this.props.passedAppFunctions.siteFormat == 'tablet' ? (
                <MainImagePhotoSwipeZoom
                  isOpen={this.state.isOpen}
                  options={this.state.options}
                  passedFunctions={this.props.passedFunctions}
                  handleClose={this.handleClose}
                  contentData={this.props.contentData}
                  selectedMainImg={this.props.passedFunctions.parentState.selectedMainImg}
                  updateZoomIndex={this.updateZoomIndex}
                />
              ) : (
                <PhotoSwipeZoom
                  isOpen={this.state.isOpen}
                  options={this.state.options}
                  passedFunctions={this.props.passedFunctions}
                  handleClose={this.handleClose}
                  contentData={this.props.contentData}
                  selectedMainImg={this.props.passedFunctions.parentState.selectedMainImg}
                  updateZoomIndex={this.updateZoomIndex}
                />
              )}
              <div className='col-sm-6'>
                {this.props.contentData.altImages && this.props.passedAppFunctions.siteFormat == 'tablet' ? (
                  <MainImageSlider
                    contentData={this.props.contentData}
                    passedFunctions={this.props.passedFunctions}
                    passedAppFunctions={this.props.passedAppFunctions}
                    selectedMainImg={this.props.passedFunctions.parentState.selectedMainImg}
                    openPhotoSwipeMain={this.openPhotoSwipeMain}
                    altClicked={this.state.altClicked}
                    altIndex={this.state.altIndex}
                  />
                ) : (
                  <MainImage
                    passedFunctions={this.props.passedFunctions}
                    passedAppFunctions={this.props.passedAppFunctions}
                    contentData={this.props.contentData}
                    selectedMainImg={this.props.passedFunctions.parentState.selectedMainImg}
                    openPhotoSwipe={this.openPhotoSwipe}
                  />
                )}

                {this.props.passedAppFunctions.siteFormat == 'tablet' ? (
                  <span className='tapToZoom'>Tap image to zoom</span>
                ) : (
                  ''
                )}
                {this.state.deviceWidth < 769 || this.props.passedAppFunctions.siteFormat == 'tablet' ? (
                  //Alts displayed below MainImage for tablet.
                  <AltImages
                    contentData={this.props.contentData}
                    passedFunctions={this.props.passedFunctions}
                    passedAppFunctions={this.props.passedAppFunctions}
                    selectedMainImg={this.props.passedFunctions.parentState.selectedMainImg}
                    selectedAttributeValue={this.props.passedFunctions.parentState.selectedAttributeValue}
                    vertical={false}
                    altClicked={this.props.altClicked}
                  />
                ) : (
                  ''
                )}
                <ProductLeftRightEspot contentData={this.props.contentData} />
              </div>
              <div className='col-md-6 col-lg-5'>
                <Title contentData={this.props.contentData} passedAppFunctions={this.props.passedAppFunctions} />
                <ProductReviewStars
                  passedFunctions={this.props.passedFunctions}
                  passedAppFunctions={this.props.passedAppFunctions}
                  contentData={this.props.contentData}
                />
                <Price pricing={this.props.contentData.pricing} />
                <ProductDescription
                  open={true}
                  contentData={this.props.contentData}
                  passedAppFunctions={this.props.passedAppFunctions}
                />
                <BrandDescription
                  open={false}
                  contentData={this.props.contentData}
                  passedAppFunctions={this.props.passedAppFunctions}
                />
                <ProductShipping contentData={this.props.contentData} />
                <ProductMisc
                  contentData={this.props.contentData}
                  passedFunctions={this.props.passedFunctions}
                  passedAppFunctions={this.props.passedAppFunctions}
                />
                <ProductSocialMedia contentData={this.props.contentData} passedFunctions={this.props.passedFunctions} />
              </div>
            </div>
            {this.props.contentData.isInternational == 'Y' || !this.props.passedAppFunctions.isInternational() ? (
              <ProductItemComponent
                currentAttributeState={this.props.passedFunctions.parentState.currentAttributeState}
                contentData={this.props.contentData}
                passedFunctions={this.props.passedFunctions}
                passedAppFunctions={this.props.passedAppFunctions}
              />
            ) : (
              <div id='error-message' className='alert alert-danger' role='alert'>
                This item is not available for international purchase.
              </div>
            )}
          </div>

          <div className='col-sm-12 col-md-12 col-lg-2'>
            <div className='productRecsColumn'>
              <ProductRecs
                zoneName='PDPZ1'
                contentData={this.props.contentData}
                vertical={true}
                passedAppFunctions={this.props.passedAppFunctions}
              />
            </div>
          </div>
        </div>
        <div className='recentlyViewedContainer'>
          <ProductRecommendations
            widgetData={{
              zone: 'RecentlyViewed',
              scrollable: true,
              rows: 1,
              productsPerRow: 6,
              showProductTitle: true,
              title: 'Recently Viewed',
            }}
            passedAppFunctions={this.props.passedAppFunctions}
            contentData={this.props.contentData}
          />
        </div>
        <ProductDetailReviews
          contentData={this.props.contentData}
          passedAppFunctions={this.props.passedAppFunctions}
          passedFunctions={this.props.passedFunctions}
        />
        <WcPowerPage {...this.props} />
      </section>
    );
  }
}

export default ProductItemDisplay;
